// src/authConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === "development") console.log(message);
      },
    },
  },
};

export const loginRequest = {
  scopes: [
    "User.Read",
    "User.ReadBasic.All",
    "Sites.ReadWrite.All",
    "Files.ReadWrite.All",
    "Mail.Send",
    "GroupMember.Read.All",
    "offline_access",
  ],
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users",
  graphGroupsEndpoint: "https://graph.microsoft.com/v1.0/groups",
};

export const sharePointConfig = {
  siteUrl: process.env.REACT_APP_SHAREPOINT_SITE_URL,
  siteId: process.env.REACT_APP_SHAREPOINT_SITE_ID,
  tenantDomain: process.env.REACT_APP_TENANT_DOMAIN,
  lists: {
    contracts: "Contracts",
    contractRequests: "ContractRequests",
    allowedUsers: "AllowedUsers",
    templates: "ContractTemplates",
    auditLog: "AuditLog",
  },
  documentLibraries: {
    contracts: "ContractDocuments",
    templates: "ContractTemplates",
  },
};
